/**
 * @ngdoc directive
 * @name cbl.insuranceloanpmi.mf.directive:creasSceltaConvenzione
 * @restrict E
 * @description Componente che gestisce il primo sotto-step "Scelta Convenzione" dello step "Pagamento"
 * @param {Object[]} convenzioni - Array delle convenzioni disponibili
 */
(function() {
  'use strict';
  var CreasSceltaConvenzioneCtrl = function(
    $http,
    $scope,
    $state,
    $stateParams,
    $window,
    $q,
    $httpParamSerializer,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    dettPraticaSrvc
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$window = $window;
    this.messaggiFctr = messaggiFctr;
    this.dettPraticaSrvc = dettPraticaSrvc;
    this.CONSTANTS = CONSTANTS;
    $scope.msg = labelSrvc.getLabel;
    this.convenzioni = [];

    // this.convenzioni = [];
    // Spinner
    this.spinner = dettPraticaSrvc.spinner;
    this.subSpinner = {
    	convenzioni: false
    };

    var self = this;

    // Configuro l'abilitazione dei pulsanti di scorrimento tra gli step
    dettPraticaSrvc.isCancelFinanziamentoVisible = function() {
      return true;
    };
    dettPraticaSrvc.isCancelFinanziamentoEnabled = function() {
      return true;
    };
      
    dettPraticaSrvc.isSaveEnabled = function() {
      return self.dettPraticaSrvc.convenzione !== null;
    };

    dettPraticaSrvc.isNextEnabled = function() {
      return self.dettPraticaSrvc.convenzione !== null;
    };
    
    // Configuro il comportamento del pulsante prosegui per lo step
    dettPraticaSrvc.nextStep = function() {
    	
		self.spinner.pratica = true;
		
		// Se le polizze sono già state assegnate, procedo direttamente allo step successivo
		if (self.finanziamentoGiaAperto() === true) {
			
			$q
            .all({
              nextStep: self.dettPraticaSrvc.promiseCambiaStep('/avantiStep')
            })
            .then(
              function(response) {
                if (self.messaggiFctr.processaResponse(response.nextStep)) {
                  return;
                }
                
                self.dettPraticaSrvc.datiPratica = response.nextStep.data.result;
                dettPraticaSrvc.generaTabs();
              },
              function(reason) {
                self.messaggiFctr.processaResponse(reason.nextStep);
              }
            )
            .finally(function() {
              self.spinner.pratica = false;
            });
			
		} else {
			
			$q
			.all({salvaConvenzione: self.dettPraticaSrvc.promiseSalvaConvenzione()})
			.then(
			  function(response) {
				  if (response.salvaConvenzione.data.result) {
		            $q
		              .all({
		                nextStep: self.dettPraticaSrvc.promiseCambiaStep('/avantiStep')
		              })
		              .then(
		                function(response) {
		                  if (self.messaggiFctr.processaResponse(response.nextStep)) {
		                    return;
		                  }
		                  
		                  self.dettPraticaSrvc.datiPratica = response.nextStep.data.result;
		                  dettPraticaSrvc.generaTabs();
		                },
		                function(reason) {
		                  self.messaggiFctr.processaResponse(reason.nextStep);
		                }
		              )
		              .finally(function() {
		                self.spinner.pratica = false;
		              });
		          } else {
		            self.spinner.pratica = false;
		          }
			  },
			  function(reason) {
			    self.messaggiFctr.processaResponse(reason.salvaConvenzione);
			    self.spinner.pratica = false;
			  }
			);
			
		}
    	
    };

    // Configuro il comportamento del pulsante salva per lo step
    dettPraticaSrvc.salva = function() {
      self.spinner.pratica = true;
      
      $q
        .all({salvaConvenzione: self.dettPraticaSrvc.promiseSalvaConvenzione()})
        .then(
          function(response) {
            self.dettPraticaSrvc.datiPratica = response.salvaConvenzione.data.result;
            if (self.messaggiFctr.processaResponse(response.salvaConvenzione)) {
              return;
            }
          },
          function(reason) {
            self.messaggiFctr.processaResponse(reason.salvaConvenzione);
          }
        )
        .finally(function() {
          self.spinner.pratica = false;
        });
    };
    
    /**
	 * @ngdoc method
	 * @name recuperaConvenzioni
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasSceltaConvenzione
	 * @description Recupera le convenzioni per l'affidamento attuale
	 */
    this.recuperaConvenzioni = function() {
      self.subSpinner.convenzioni = true;
      $q
        .all({
          convenzioni: self.dettPraticaSrvc.promiseConvenzioni()
        })
        .then(
          function(response) {
            if (self.messaggiFctr.processaResponse(response.convenzioni)) {
              self.convenzioni = [];
              return;
            }
            self.convenzioni = response.convenzioni.data.result;
            
            self.impostaConvenzioneSelezionata();
          },
          function(reason) {
            self.messaggiFctr.processaResponse(reason.convenzioni);
            self.convenzioni = [];
          }
        )
        .finally(function() {
		  self.subSpinner.convenzioni = false;
		});
    };

    /**
	 * @ngdoc method
	 * @name impostaConvenzioneSelezionata
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasSceltaConvenzione
	 * @description Se disponibile, imposta in visualizzazione la convenzione selezionata per la pratica
	 */
    this.impostaConvenzioneSelezionata = function() {
      if (!self.dettPraticaSrvc.convenzione) {
        return;
      }
      
      angular.forEach(self.convenzioni, function(value) {
        if (self.dettPraticaSrvc.convenzione.idConvenzioneCPT === value.idConvenzione) {
          self.dettPraticaSrvc.convenzione = value;
        }
      });
    };
    
    /**
	 * @ngdoc method
	 * @name finanziamentoGiaAperto
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasSceltaConvenzione
	 * @description Indica se per la pratica in corso sono già state assegnate o meno polizze
	 * @return {boolean} True se almeno una polizza è assegnata, false se non sono state assegnate polizze
	 */
    this.finanziamentoGiaAperto = function() {
    	return self.dettPraticaSrvc.datiPratica.elencoFinanziamentoMultiPolizzaPMI.length > 1;
    }
    
    // Se presente nella pratica, imposto la convenzione già selezionata
    if (this.dettPraticaSrvc.datiPratica.prodotto && this.dettPraticaSrvc.datiPratica.prodotto.convenzione) {
    	this.dettPraticaSrvc.convenzione = this.dettPraticaSrvc.datiPratica.prodotto.convenzione;
    }
    
    // Recupero l'elenco convenzioni
    this.recuperaConvenzioni();
  };

  CreasSceltaConvenzioneCtrl.$inject = [
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$window',
    '$q',
    '$httpParamSerializer',
    'CONSTANTS',
    'LabelSrvc',
    'CreasMessaggiFctr',
    'CreasDettaglioPraticaSrvc'
  ];

  var TemplateUrl = function(CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'creasDettaglioPratica/creasPraticaPagamento/creasSceltaConvenzione/creasSceltaConvenzione.html'
    );
  };

  TemplateUrl.$inject = ['CONSTANTS'];

  var CreasSceltaConvenzioneComponent = {
    bindings: {
      convenzioni: '<'
    },
    controller: CreasSceltaConvenzioneCtrl,
    controllerAs: 'creasSceltaConvenzioneCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.insuranceloanpmi.mf')
    .component('creasSceltaConvenzione', CreasSceltaConvenzioneComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/creasDettaglioPratica/creasPraticaPagamento/creasSceltaConvenzione/creasSceltaConvenzione.cmpt.js
// module id = 27
// module chunks = 0 1